import classNames from "classnames";
import type { AvatarSize } from "@design-system/Avatar/Avatar";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { WorkspaceAvatar } from "@design-system/Avatar/WorkspaceAvatar";
import styles from "./WorkspaceName.module.scss";

interface WorkspaceNameProps {
    workspace: {
        id: string;
        name: string;
        iconColor?: string | null;
    };
    isIconVisible?: boolean;
    iconSize?: AvatarSize;
    className?: string;
    nameClassName?: string;
    isTooltipVisible?: boolean;
}

export const WorkspaceName = ({
    workspace,
    isIconVisible = true,
    iconSize = "xs",
    className,
    nameClassName,
    isTooltipVisible,
}: WorkspaceNameProps) => (
    <span className={classNames(styles.container, className)}>
        {isIconVisible ? (
            <WorkspaceAvatar
                workspace={{
                    name: workspace.name,
                    iconColor: workspace.iconColor ?? null,
                }}
                size={iconSize}
                aria-hidden
            />
        ) : null}
        <BreakableText
            text={workspace.name}
            className={nameClassName}
            copyId={workspace.id}
            copyLabel="Workspace"
            showTooltip={isTooltipVisible}
        />
    </span>
);
